import { inject, observer } from 'mobx-react'
import { PageView, TurnstileContainer, TextTurnstile } from './index.styled'
import Turnstile from 'react-turnstile'

const TurnstileView = (props) => {
  const { language, onVerify, onExpire } = props

  return (
    <PageView>
      <TextTurnstile>
        {language.getMsg('Verify', 'ยืนยันบัญชี')}
        <span>
          {language.getMsg(
            '(Click the box if is not clicked)',
            '(กดที่ช่องด้านล่าง หากไม่ได้ตรวจสอบอัตโนมัติ)'
          )}
        </span>
      </TextTurnstile>
      <TurnstileContainer>
        <Turnstile
          sitekey={
            process.env.REACT_APP_TURNSTILE_SITE_KEY ||
            '0x4AAAAAAAwmWTHbYb3D7Un7'
          }
          retry="auto"
          refreshExpired="auto"
          size="flexible"
          onSuccess={onVerify}
          onExpire={onExpire}
          language={language?.selected || 'en'}
        />
      </TurnstileContainer>
    </PageView>
  )
}

export default inject('language')(observer(TurnstileView))
